<template>
    <a v-if="item.MediaSelect" class="card card-horizontal card-event" target="_blank" v-bind:href="formatMediaSelect(item.MediaSelect)">
        <div class="card-content resource-card-content col-1">
            <span v-if="item.ResourceType == 'video'" class="card-icon resource-icon icon-play"></span>
            <span v-if="item.ResourceType == 'pdf'" class="card-icon resource-icon icon-pdf"></span>
            <span v-if="item.ResourceType == 'webpage'" class="card-icon resource-icon icon-window"></span>
            <span v-if="item.ResourceType == 'image'" class="card-icon resource-icon icon-image-square"></span>
        </div>
        <div class="card-content resource-content">
            <div class="resource-text title-wrap">
                <h3>{{ item.Title }}</h3>
            </div>
            <div class="resource-text blurb">
                <p>{{ item.Description }}</p>
            </div>
        </div>
    </a>
    <a v-else-if="item.InternalURL" class="card card-horizontal card-event" target="_blank" v-bind:href="item.InternalURL">
        <div class="card-content resource-card-content col-1">
            <span v-if="item.ResourceType == 'video'" class="card-icon resource-icon icon-play"></span>
            <span v-if="item.ResourceType == 'pdf'" class="card-icon resource-icon icon-pdf"></span>
            <span v-if="item.ResourceType == 'webpage'" class="card-icon resource-icon icon-window"></span>
            <span v-if="item.ResourceType == 'image'" class="card-icon resource-icon icon-image-square"></span>
        </div>
        <div class="card-content resource-content">
            <div class="resource-text title-wrap">
                <h3>{{ item.Title }}</h3>
            </div>
            <div class="resource-text blurb">
                <p>{{ item.Description }}</p>
            </div>
        </div>
    </a>
    <a v-else class="card card-horizontal card-event" target="_blank" v-bind:href="item.ExternalURL">
        <div class="card-content resource-card-content col-1">
            <span v-if="item.ResourceType == 'video'" class="card-icon resource-icon icon-play"></span>
            <span v-if="item.ResourceType == 'pdf'" class="card-icon resource-icon icon-pdf"></span>
            <span v-if="item.ResourceType == 'webpage'" class="card-icon resource-icon icon-window"></span>
            <span v-if="item.ResourceType == 'image'" class="card-icon resource-icon icon-image-square"></span>
        </div>
        <div class="card-content resource-content">
            <div class="resource-text title-wrap">
                <h3>{{ item.Title }}</h3>
            </div>
            <div class="resource-text blurb">
                <p>{{ item.Description }}</p>
            </div>
        </div>
    </a>
</template>

<script>
export default {
        props: ['item'],
        methods: {
            formatMediaSelect(media) {
                var url = new URL(location.href);
                var domain = url.hostname;
                media = media.substring(1);
                var editedURL = 'https://' + domain + '/' + media;
                return editedURL;
            }
        }
}
</script>